// ============================================
// CONPLANTAS — MOTOR DEL CONTADOR DE ENTREGA
// ============================================
// Lee la configuración global del tema publicada por
// snippets/cp-countdown-config.liquid en window.cpCountdownConfig
// y expone window.cpCountdown.getState() para el home y la ficha.

(function () {
  'use strict';

  var DEFAULTS = {
    enabled: true,
    slots: [
      { cutoff: '07:00', window: '7am – 9am' },
      { cutoff: '09:00', window: '9am – 11am' },
      { cutoff: '11:00', window: '11am – 1pm' },
      { cutoff: '13:00', window: '1pm – 3pm' },
      { cutoff: '15:00', window: '3pm – 5pm' },
      { cutoff: '17:00', window: '5pm – 7pm' },
      { cutoff: '19:00', window: '5pm – 7pm' }
    ],
    days: { 0: true, 1: true, 2: true, 3: true, 4: true, 5: true, 6: true },
    text: {
      prefix: 'Pide antes de',
      desc: 'y recibe hoy',
      closedLabel: 'Entregas cerradas por hoy',
      closedDesc: 'Reabre mañana'
    }
  };

  var DAY_NAMES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var WEEKDAY_INDEX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function config() {
    var raw = window.cpCountdownConfig || {};
    return {
      enabled: raw.enabled !== false,
      slots: (raw.slots && raw.slots.length) ? raw.slots : DEFAULTS.slots,
      days: raw.days || DEFAULTS.days,
      text: {
        prefix: (raw.text && raw.text.prefix) || DEFAULTS.text.prefix,
        desc: (raw.text && raw.text.desc) || DEFAULTS.text.desc,
        closedLabel: (raw.text && raw.text.closedLabel) || DEFAULTS.text.closedLabel,
        closedDesc: (raw.text && raw.text.closedDesc) || DEFAULTS.text.closedDesc
      }
    };
  }

  // Las franjas son las de la tienda (Bogotá, GMT-5), no las del dispositivo del
  // visitante. Si el celular está en otra zona horaria, igual debe ver la franja
  // real de entrega.
  function storeNow() {
    try {
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Bogota',
        hourCycle: 'h23',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
      var parts = {};
      fmt.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      return {
        day: WEEKDAY_INDEX[parts.weekday],
        minutes: parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10),
        seconds: parseInt(parts.second, 10)
      };
    } catch (e) {
      var d = new Date();
      return {
        day: d.getDay(),
        minutes: d.getHours() * 60 + d.getMinutes(),
        seconds: d.getSeconds()
      };
    }
  }

  function toMinutes(hhmm) {
    var m = /^(\d{1,2}):(\d{2})$/.exec(String(hhmm).trim());
    if (!m) return null;
    var h = parseInt(m[1], 10);
    var min = parseInt(m[2], 10);
    if (h > 23 || min > 59) return null;
    return h * 60 + min;
  }

  // "13:00" -> "la 1:00pm" · "07:00" -> "las 7:00am"
  function cutoffLabel(hhmm) {
    var total = toMinutes(hhmm);
    if (total === null) return hhmm;
    var h24 = Math.floor(total / 60);
    var min = total % 60;
    var suffix = h24 < 12 ? 'am' : 'pm';
    var h12 = h24 % 12;
    if (h12 === 0) h12 = 12;
    var article = h12 === 1 ? 'la' : 'las';
    return article + ' ' + h12 + ':' + (min < 10 ? '0' : '') + min + suffix;
  }

  function parsedSlots(cfg) {
    return cfg.slots
      .map(function (s) {
        return { minutes: toMinutes(s.cutoff), cutoff: s.cutoff, window: s.window };
      })
      .filter(function (s) { return s.minutes !== null && s.window; })
      .sort(function (a, b) { return a.minutes - b.minutes; });
  }

  function isDeliveryDay(cfg, dayIndex) {
    return cfg.days[dayIndex] !== false;
  }

  // Días que faltan hasta el próximo día con entrega (1 = mañana).
  function daysUntilNextOpen(cfg, fromDay) {
    for (var i = 1; i <= 7; i++) {
      if (isDeliveryDay(cfg, (fromDay + i) % 7)) return i;
    }
    return null; // no hay ningún día activo
  }

  function getState() {
    var cfg = config();
    if (!cfg.enabled) return { enabled: false };

    var slots = parsedSlots(cfg);
    var now = storeNow();

    if (!slots.length) return { enabled: false };

    var active = null;
    if (isDeliveryDay(cfg, now.day)) {
      for (var i = 0; i < slots.length; i++) {
        if (now.minutes < slots[i].minutes) { active = slots[i]; break; }
      }
    }

    if (active) {
      var remainingMs = ((active.minutes - now.minutes) * 60 - now.seconds) * 1000;
      return {
        enabled: true,
        closed: false,
        label: cfg.text.prefix + ' ' + cutoffLabel(active.cutoff),
        desc: cfg.text.desc,
        window: active.window,
        remainingMs: remainingMs
      };
    }

    // Cerrado: cuenta hasta el inicio (00:00) del próximo día con entrega.
    var offset = daysUntilNextOpen(cfg, now.day);
    if (offset === null) {
      return { enabled: true, closed: true, label: cfg.text.closedLabel, desc: '', window: '', remainingMs: 0 };
    }

    var minutesLeftToday = 24 * 60 - now.minutes;
    var remaining = ((minutesLeftToday + (offset - 1) * 24 * 60) * 60 - now.seconds) * 1000;
    var whenText = offset === 1 ? 'mañana' : 'el ' + DAY_NAMES[(now.day + offset) % 7];
    var closedDesc = cfg.text.closedDesc.replace(/\bmañana\b/i, whenText);
    if (closedDesc === cfg.text.closedDesc && whenText !== 'mañana') {
      closedDesc = cfg.text.closedDesc + ' ' + whenText;
    }

    return {
      enabled: true,
      closed: true,
      label: cfg.text.closedLabel,
      desc: closedDesc,
      window: 'Primera franja: ' + slots[0].window,
      remainingMs: remaining
    };
  }

  function formatDuration(ms) {
    if (ms < 0) ms = 0;
    var totalSeconds = Math.floor(ms / 1000);
    var h = Math.floor(totalSeconds / 3600);
    var m = Math.floor((totalSeconds % 3600) / 60);
    var s = totalSeconds % 60;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  window.cpCountdown = { getState: getState, formatDuration: formatDuration };
})();
